import React from 'react';
import { Table, Th, Tr, Td} from '../Common/DataTable.Styles.js';


const ObjectGroupTable = ({ objectGroups, selectedGroupId, onGroupSelect }) => {
  return (
      <div>
        <Table>
          <thead>
            <Tr>
              <Th>Object Type</Th>
            </Tr>
          </thead>
          <tbody>
            {objectGroups.map((group, index) => {
              const isSelected = selectedGroupId === group.id;
  
              return (
                <Tr
                  key={group.id}
                  onClick={() => onGroupSelect(group.id)}
                  $isSelected={isSelected}
                  $alternate={index % 2 === 1}
                  style={{ cursor: 'pointer' }}
                >
                  <Td>{group.name}</Td>
                </Tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };
  
  export default ObjectGroupTable;